import { FC, ReactNode, useEffect } from 'react';
import Header from './Header';
import styles from './Layout.module.scss';
import { trackStartPersonalizedInsole } from '../../services/google_analytics';
interface LayoutProps {
  children: ReactNode;
}

const Layout: FC<LayoutProps> = ({ children }) => {

  useEffect(() => {
    trackStartPersonalizedInsole();
  }, []);

  return (
    <div className={styles.layout}>
      <Header />
      <main className={styles.main}>
        {children}
      </main>
      <div id="modal-root" />
    </div>
  );
};

export default Layout;
